(() => {
  /**
   * SparkleAI module for Quill editor
   * Built for use with the SpAiGeneratorQuillApp custom element
   *
   * @param {Quill} quill
   * @param {Object} options
   * @param {import('../../../../../../frontend/src/custom_elements/apps/SpAiGeneratorQuillApp/App.ce.vue').default} options.container
   * @param {string} options.menuUrl
   */
  class SparkleAI {
    constructor(quill, { container, menuUrl }) {
      container.quill = quill;
      container.menuConfigUrl = menuUrl;
    }
  }
  Quill.register("modules/sparkle_ai", SparkleAI);
})();
